module.exports = __webpack_public_path__ + "static/media/td.e2777e74.svg";